import "@/App.css";
import { useState, useEffect } from "react";
import { 
  Download, 
  Mail, 
  Phone, 
  MapPin, 
  Linkedin, 
  Github,
  ChevronDown,
  Award,
  Briefcase,
  GraduationCap,
  Code,
  Languages,
  ExternalLink
} from "lucide-react";

// CV Data
const cvData = {
  personal: {
    name: "Majed GHORBEL",
    title: "SysOps / DevOps / SRE Engineer",
    email: "mejedgorbel@ymail.com",
    phone: "07 52 81 20 87",
    location: "Paris 75, France",
    linkedin: "https://www.linkedin.com/in/majed-ghorbel-60328b54/",
    github: "https://github.com/majedghorbel",
    photo: "/profile-photo.png"
  },
  summary: "Professionnel polyvalent avec une expertise approfondie en DevOps, SRE, ingénierie système et réseau, ainsi qu'en développement logiciel. J'apporte mes connaissances à des fins d'automatisation des processus de développement, à la gestion d'infrastructures complexes et à la garantie de la fiabilité des systèmes critiques. Animé par une forte passion pour l'innovation et une capacité à travailler efficacement en équipe, j'ai conçu et mis en œuvre des solutions performantes et fiables. Toujours prêt à relever de nouveaux défis techniques, je m'engage à améliorer constamment la qualité, la fiabilité et les performances des produits que je développe.",
  experience: [
    {
      company: "SACEM",
      role: "SysOps / DevOps",
      period: "Sept 2025 - Présent",
      duration: "1 an 1 mois",
      location: "Neuilly, France",
      highlights: [
        "Conteneurisation Docker, Kubernetes",
        "Administration de systèmes: Linux Redhat, Windows Server",
        "IaC et scripting: Ansible, Terraform, Python",
        "Cloud AWS: Route 53, Cloudfront, ECS, ELB, S3, ApiGateway",
        "Observabilité: Prometheus, Grafana, OpenSearch, Logstash, Cloudwatch",
        "CICD: Gitlab, Artifactory, Nexus, Sonar",
        "Agilité et Méthodologie Safé",
        "Migrations, gestion d'obsolésence et MCO"
      ]
    },
    {
      company: "OVHcloud",
      role: "DevOps / SRE",
      period: "Sept 2022 - Sept 2025",
      duration: "3 ans",
      location: "Paris, France",
      highlights: [
        "Garantir la fiabilité des sites hébergeant la solution de stockage d'objets de l'offre cloud public",
        "Surveillance continue du respect du SLA pour le service Object Storage (HAProxy, OpenStack, RabbitMQ, MongoDB, Redpanda)",
        "Mise en place d'outils d'observabilité (Grafana, OpenSearch, Syslog, GrayLog)",
        "Développement de probes et sondes avec Prometheus, Alert Manager, Netdata, Collectd",
        "Déploiement sur Kubernetes, Docker, CDS CI/CD",
        "Automatisation avec Python, Perl, Puppet, Terraform, Ansible, Ruby",
        "Migration Debian vers Ubuntu et automatisation du déploiement",
        "Leadership des événements Scrum"
      ]
    },
    {
      company: "Worldline",
      role: "Ingénieur DevOps",
      period: "Juin 2021 - Sept 2022",
      duration: "1 an 4 mois",
      location: "Puteaux, France",
      highlights: [
        "Déploiement du nouveau siège de Worldline France et intégration d'INGENICO",
        "Mise en place de l'architecture globale et tests de haute disponibilité",
        "Configuration des équipements de sécurité et VPN SSL/IPSEC",
        "Déploiement 802.1X et certificats d'entreprise",
        "Mise en production de la plateforme de monitoring et alerting"
      ]
    },
    {
      company: "Ingenico",
      role: "Ingénieur SysOps",
      period: "Sept 2020 - Sept 2022",
      duration: "2 ans 1 mois",
      location: "France (Multi-sites)",
      highlights: [
        "Migration système et réseaux, décommissionnement du site Grenelle",
        "Supervision avec Zabbix, Zabbix Proxy et Grafana",
        "Plan de reprise d'activité sur Microsoft Azure",
        "Développement de tableaux de bord SLA/KPI",
        "Développement d'un chat bot interne avec Power Virtual Agent",
        "Planification et exécution des migrations de data centers"
      ]
    },
    {
      company: "BNP Paribas Partners for Innovation",
      role: "Ingénieur Cloud Computing",
      period: "Mars 2019 - Sept 2020",
      duration: "1 an 7 mois",
      location: "Montreuil, France",
      highlights: [
        "Gestion de l'orchestrateur de la plateforme cloud privée BNP Paribas",
        "Administration IBM multicloud (IaaS, PaaS, SaaS)",
        "Support niveau 3 des services cloud (FWaaS, VM, DBaaS, FileaaS, LBaaS)",
        "Création de playbooks Ansible et scripts d'automatisation",
        "Intégration et provisionnement des clusters HCI et VBlocks"
      ]
    },
    {
      company: "Plug & Tel",
      role: "Ingénieur Systèmes et Réseaux",
      period: "Mars 2018 - Fév 2019",
      duration: "1 an",
      location: "Tunis, Tunisie",
      highlights: [
        "Pipeline CI/CD avec GitLab, AWS et Docker",
        "Plateformes de surveillance EyesOfNetwork, WeatherMap, Smokeping",
        "Gestion des environnements VMware vCenter, ESXi et Proxmox",
        "Configuration routeurs, switches et firewalls Dell, Cisco, Juniper",
        "Rédaction PCA, PRA et plans de reprise après sinistre"
      ]
    },
    {
      company: "LAMSIN",
      role: "Ingénieur Système et Réseaux",
      period: "Déc 2015 - Mars 2018",
      duration: "2 ans 4 mois",
      location: "Tunis, Tunisie",
      highlights: [
        "Responsable du Système d'Information du laboratoire de recherche",
        "Gestion du parc informatique Windows et Linux",
        "Masterisation WDS via PXE et déploiement WSUS",
        "Virtualisation Hyper-V, supervision Nagios et Cacti",
        "Administrateur du programme AWS-EDUCATE"
      ]
    },
    {
      company: "Prosperi",
      role: "Développeur SharePoint",
      period: "Juil 2014 - Juin 2015",
      duration: "1 an",
      location: "Vitoria, Brésil",
      highlights: [
        "Développement de solutions d'entreprise Microsoft EPM",
        "MS Project Server, SharePoint Server, MS SQL Server, TFS, C#",
        "Travail en équipe Scrum"
      ]
    }
  ],
  education: [
    {
      institution: "ESPRIT - École Supérieure Privée d'Ingénierie et de Technologies",
      degree: "Diplôme National d'Ingénieur",
      field: "Ingénierie Informatique",
      period: "2011 - 2014"
    },
    {
      institution: "ISET Sfax - Institut Supérieur des Études Technologiques",
      degree: "Licence Appliquée en Informatique",
      field: "Réseaux et Systèmes Informatique",
      period: "2008 - 2011"
    },
    {
      institution: "Lycée 15 Novembre 1955 de Sfax",
      degree: "Baccalauréat",
      field: "Sciences Informatique",
      period: "2004 - 2008"
    }
  ],
  certifications: [
    { name: "AWS Certified Solutions Architect Associate", code: "SAA-C03", provider: "AWS" },
    { name: "AWS Certified Cloud Practitioner", code: "CLF-C02", provider: "AWS" },
    { name: "Microsoft Certified: Azure Fundamentals", code: "AZ-900", provider: "Microsoft" },
    { name: "Microsoft Certified: Azure Data Fundamentals", code: "DP-900", provider: "Microsoft" },
    { name: "Microsoft Certified: Power Platform Fundamentals", code: "PL-900", provider: "Microsoft" },
    { name: "Microsoft Certified: Security Compliance and Identity", code: "SC-900", provider: "Microsoft" },
    { name: "Professional Scrum Master", code: "PSM-I", provider: "Scrum.org" },
    { name: "Fortinet Certified: Fundamentals Cybersecurity", code: "", provider: "Fortinet" },
    { name: "Conduire et piloter un projet innovant avec méthodes agiles", code: "RS6099", provider: "France Compétences" }
  ],
  skills: {
    devops: ["Kubernetes", "Docker", "Terraform", "Ansible", "Puppet", "GitLab CI/CD", "CDS CI/CD", "Jenkins"],
    cloud: ["AWS", "Microsoft Azure", "OpenStack", "IBM Multicloud", "VMware vCenter", "Proxmox", "Hyper-V"],
    monitoring: ["Prometheus", "Grafana", "Zabbix", "Nagios", "OpenSearch", "GrayLog", "Alert Manager", "Netdata"],
    systems: ["Linux (Debian/Ubuntu)", "Windows Server", "HAProxy", "Nginx", "Active Directory", "DNS", "DHCP"],
    storage: ["MongoDB", "OpenStack Swift", "OpenIO S3", "RabbitMQ", "Redpanda", "MySQL", "MS SQL Server"],
    programming: ["Python", "Perl", "Ruby", "Bash/Shell", "PowerShell", "JavaScript", "PHP", "SQL", "C#"],
    networking: ["VPN SSL/IPSEC", "802.1X", "Cisco", "Juniper", "Dell", "Firewalls", "Load Balancing"],
    methodologies: ["Scrum", "ITIL", "DevOps", "SRE", "Agile", "CI/CD"]
  },
  languages: [
    { name: "Français", level: "Natif / Bilingue", percent: 100 },
    { name: "Arabe", level: "Natif / Bilingue", percent: 100 },
    { name: "Anglais", level: "Professionnel", percent: 80 },
    { name: "Portugais", level: "Élémentaire", percent: 30 }
  ]
};

// Components
const Section = ({ id, title, icon: Icon, children }) => (
  <section id={id} className="py-16 border-b border-slate-800/50" data-testid={`section-${id}`}>
    <div className="flex items-center gap-3 mb-8">
      <div className="p-2 bg-gradient-to-br from-cyan-500/20 to-blue-500/20 rounded-lg border border-cyan-500/30">
        <Icon className="w-5 h-5 text-cyan-400" />
      </div>
      <h2 className="text-2xl font-bold text-white tracking-tight">{title}</h2>
    </div>
    {children}
  </section>
);

const SkillTag = ({ skill }) => (
  <span className="px-3 py-1.5 bg-slate-800/80 text-slate-300 text-sm rounded-full border border-slate-700/50 hover:border-cyan-500/50 hover:text-cyan-400 transition-all duration-300 cursor-default">
    {skill}
  </span>
);

const ProgressBar = ({ percent, label }) => (
  <div className="flex items-center gap-4">
    <span className="w-24 text-slate-400 text-sm">{label}</span>
    <div className="flex-1 h-2 bg-slate-800 rounded-full overflow-hidden">
      <div 
        className="h-full bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full transition-all duration-1000"
        style={{ width: `${percent}%` }}
      />
    </div>
    <span className="w-12 text-right text-slate-500 text-sm">{percent}%</span>
  </div>
);

const ExperienceCard = ({ exp, isExpanded, onToggle }) => (
  <div 
    className="group bg-slate-900/50 rounded-xl border border-slate-800/50 hover:border-cyan-500/30 transition-all duration-300 overflow-hidden"
    data-testid={`experience-${exp.company.toLowerCase().replace(/\s+/g, '-')}`}
  >
    <button 
      onClick={onToggle}
      className="w-full p-6 text-left flex items-start justify-between gap-4"
      aria-expanded={isExpanded}
    >
      <div className="flex-1">
        <div className="flex flex-wrap items-center gap-2 mb-1">
          <h3 className="text-lg font-semibold text-white group-hover:text-cyan-400 transition-colors">
            {exp.role}
          </h3>
          <span className="text-cyan-400">@</span>
          <span className="text-cyan-400 font-medium">{exp.company}</span>
        </div>
        <div className="flex flex-wrap items-center gap-3 text-sm text-slate-500">
          <span>{exp.period}</span>
          <span className="w-1 h-1 bg-slate-600 rounded-full" />
          <span>{exp.duration}</span>
          <span className="w-1 h-1 bg-slate-600 rounded-full" />
          <span>{exp.location}</span>
        </div>
      </div>
      <ChevronDown 
        className={`w-5 h-5 text-slate-500 transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}
      />
    </button>
    <div className={`overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-[800px] opacity-100' : 'max-h-0 opacity-0'}`}>
      <ul className="px-6 pb-6 space-y-2">
        {exp.highlights.map((highlight, i) => (
          <li key={i} className="flex items-start gap-3 text-slate-400 text-sm">
            <span className="w-1.5 h-1.5 bg-cyan-500 rounded-full mt-2 flex-shrink-0" />
            {highlight}
          </li>
        ))}
      </ul>
    </div>
  </div>
);

const CertificationCard = ({ cert }) => (
  <div 
    className="p-4 bg-slate-900/50 rounded-xl border border-slate-800/50 hover:border-cyan-500/30 transition-all duration-300 group"
    data-testid={`cert-${cert.code || cert.name.slice(0, 10)}`}
  >
    <div className="flex items-start gap-3">
      <div className="p-2 bg-gradient-to-br from-amber-500/20 to-orange-500/20 rounded-lg border border-amber-500/30 group-hover:border-amber-400/50 transition-colors">
        <Award className="w-4 h-4 text-amber-400" />
      </div>
      <div className="flex-1 min-w-0">
        <h4 className="text-sm font-medium text-white truncate group-hover:text-amber-400 transition-colors">
          {cert.name}
        </h4>
        <div className="flex items-center gap-2 mt-1">
          {cert.code && (
            <span className="text-xs text-cyan-400 font-mono bg-cyan-500/10 px-2 py-0.5 rounded">
              {cert.code}
            </span>
          )}
          <span className="text-xs text-slate-500">{cert.provider}</span>
        </div>
      </div>
    </div>
  </div>
);

function App() {
  const [expandedExp, setExpandedExp] = useState(0);
  const [activeSection, setActiveSection] = useState('about');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['about', 'experience', 'education', 'certifications', 'skills', 'languages'];
      for (const section of sections) {
        const el = document.getElementById(section);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 100 && rect.bottom >= 100) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const navHeight = 80; // Account for fixed nav
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - navHeight;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  const navItems = [
    { id: 'about', label: 'Profil' },
    { id: 'experience', label: 'Expérience' },
    { id: 'education', label: 'Formation' },
    { id: 'certifications', label: 'Certifications' },
    { id: 'skills', label: 'Compétences' },
    { id: 'languages', label: 'Langues' }
  ];

  return (
    <div className="min-h-screen bg-slate-950 text-slate-300" data-testid="cv-app">
      {/* Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-slate-950/90 backdrop-blur-xl border-b border-slate-800/50" data-testid="main-nav">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">
          <div className="flex items-center justify-between h-16">
            <span className="text-lg font-bold text-white">
              <span className="text-cyan-400">M</span>G
            </span>
            <div className="hidden md:flex items-center gap-1">
              {navItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`px-4 py-2 text-sm rounded-lg transition-all duration-300 ${
                    activeSection === item.id 
                      ? 'text-cyan-400 bg-cyan-500/10' 
                      : 'text-slate-400 hover:text-white hover:bg-slate-800/50'
                  }`}
                  data-testid={`nav-${item.id}`}
                >
                  {item.label}
                </button>
              ))}
            </div>
            <a
              href="/CV_Majed_GHORBEL.pdf"
              download
              className="flex items-center gap-2 px-4 py-2 bg-gradient-to-r from-cyan-500 to-blue-500 text-white text-sm font-medium rounded-lg hover:from-cyan-400 hover:to-blue-400 transition-all duration-300 shadow-lg shadow-cyan-500/25"
              data-testid="download-cv-btn"
            >
              <Download className="w-4 h-4" />
              <span className="hidden sm:inline">Télécharger CV</span>
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <header className="pt-24 pb-16 px-4 sm:px-6" data-testid="hero-section">
        <div className="max-w-6xl mx-auto">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            {/* Photo */}
            <div className="relative group">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl overflow-hidden border-2 border-slate-800 group-hover:border-cyan-500/50 transition-all duration-500">
                <img 
                  src={cvData.personal.photo} 
                  alt={cvData.personal.name}
                  className="w-full h-full object-cover object-[center_10%]"
                />
              </div>
              <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-blue-500 rounded-2xl opacity-20 blur-xl group-hover:opacity-30 transition-opacity -z-10" />
            </div>

            {/* Info */}
            <div className="text-center md:text-left flex-1">
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-2 tracking-tight">
                {cvData.personal.name}
              </h1>
              <p className="text-xl md:text-2xl text-cyan-400 font-medium mb-6">
                {cvData.personal.title}
              </p>
              
              {/* Contact Info */}
              <div className="flex flex-wrap justify-center md:justify-start gap-4 text-sm">
                <a 
                  href={`mailto:${cvData.personal.email}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors"
                  data-testid="contact-email"
                >
                  <Mail className="w-4 h-4" />
                  {cvData.personal.email}
                </a>
                <a 
                  href={`tel:${cvData.personal.phone}`}
                  className="flex items-center gap-2 text-slate-400 hover:text-cyan-400 transition-colors"
                  data-testid="contact-phone"
                >
                  <Phone className="w-4 h-4" />
                  {cvData.personal.phone}
                </a>
                <span className="flex items-center gap-2 text-slate-400" data-testid="contact-location">
                  <MapPin className="w-4 h-4" />
                  {cvData.personal.location}
                </span>
              </div>

              {/* Social Links */}
              <div className="flex justify-center md:justify-start gap-3 mt-6">
                <a
                  href={cvData.personal.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="p-3 bg-slate-900 rounded-xl border border-slate-800 hover:border-cyan-500/50 hover:bg-slate-800 transition-all duration-300 group"
                  data-testid="social-linkedin"
                >
                  <Linkedin className="w-5 h-5 text-slate-400 group-hover:text-cyan-400 transition-colors" />
                </a>
                {cvData.personal.github && (
                  <a
                    href={cvData.personal.github}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-3 bg-slate-900 rounded-xl border border-slate-800 hover:border-cyan-500/50 hover:bg-slate-800 transition-all duration-300 group"
                    data-testid="social-github"
                  >
                    <Github className="w-5 h-5 text-slate-400 group-hover:text-cyan-400 transition-colors" />
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="max-w-6xl mx-auto px-4 sm:px-6">
        {/* About / Summary */}
        <Section id="about" title="Profil" icon={Briefcase}>
          <p className="text-slate-400 leading-relaxed text-lg max-w-4xl">
            {cvData.summary}
          </p>
        </Section>

        {/* Experience */}
        <Section id="experience" title="Expérience Professionnelle" icon={Briefcase}>
          <div className="space-y-4">
            {cvData.experience.map((exp, index) => (
              <ExperienceCard
                key={index}
                exp={exp}
                isExpanded={expandedExp === index}
                onToggle={() => setExpandedExp(expandedExp === index ? -1 : index)}
              />
            ))}
          </div>
        </Section>

        {/* Education */}
        <Section id="education" title="Formation" icon={GraduationCap}>
          <div className="grid gap-4">
            {cvData.education.map((edu, index) => (
              <div 
                key={index}
                className="p-6 bg-slate-900/50 rounded-xl border border-slate-800/50 hover:border-cyan-500/30 transition-all duration-300"
                data-testid={`education-${index}`}
              >
                <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                  <div>
                    <h3 className="text-lg font-semibold text-white">{edu.degree}</h3>
                    <p className="text-cyan-400">{edu.field}</p>
                    <p className="text-slate-500 text-sm mt-1">{edu.institution}</p>
                  </div>
                  <span className="text-sm text-slate-500 font-mono bg-slate-800/50 px-3 py-1 rounded-lg self-start">
                    {edu.period}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </Section>

        {/* Certifications */}
        <Section id="certifications" title="Certifications" icon={Award}>
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {cvData.certifications.map((cert, index) => (
              <CertificationCard key={index} cert={cert} />
            ))}
          </div>
        </Section>

        {/* Skills */}
        <Section id="skills" title="Compétences Techniques" icon={Code}>
          <div className="space-y-8">
            {Object.entries(cvData.skills).map(([category, skills]) => (
              <div key={category}>
                <h3 className="text-sm font-semibold text-cyan-400 uppercase tracking-wider mb-4">
                  {category === 'devops' && 'DevOps & CI/CD'}
                  {category === 'cloud' && 'Cloud & Virtualisation'}
                  {category === 'monitoring' && 'Monitoring & Observabilité'}
                  {category === 'systems' && 'Systèmes & Infrastructure'}
                  {category === 'storage' && 'Stockage & Bases de données'}
                  {category === 'programming' && 'Langages de programmation'}
                  {category === 'networking' && 'Réseaux & Sécurité'}
                  {category === 'methodologies' && 'Méthodologies'}
                </h3>
                <div className="flex flex-wrap gap-2">
                  {skills.map((skill, i) => (
                    <SkillTag key={i} skill={skill} />
                  ))}
                </div>
              </div>
            ))}
          </div>
        </Section>

        {/* Languages */}
        <Section id="languages" title="Langues" icon={Languages}>
          <div className="max-w-xl space-y-4">
            {cvData.languages.map((lang, index) => (
              <div key={index} data-testid={`language-${lang.name.toLowerCase()}`}>
                <div className="flex justify-between mb-2">
                  <span className="text-white font-medium">{lang.name}</span>
                  <span className="text-slate-500 text-sm">{lang.level}</span>
                </div>
                <div className="h-2 bg-slate-800 rounded-full overflow-hidden">
                  <div 
                    className="h-full bg-gradient-to-r from-cyan-500 to-blue-500 rounded-full transition-all duration-1000"
                    style={{ width: `${lang.percent}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </Section>
      </main>

      {/* Footer */}
      <footer className="mt-16 py-8 border-t border-slate-800/50" data-testid="footer">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 text-center">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} {cvData.personal.name}. Tous droits réservés.
          </p>
          <p className="text-slate-600 text-xs mt-2">
            Dernière mise à jour : Octobre 2026
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
